import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      {/* Header */}
      <div
        className=" text-white"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1 className="display-4 fw-bold mb-3">
                <i className="bi bi-shield-check me-3"></i>
                Privacy Policy
              </h1>
              <p className="lead mb-0">
                Your privacy is important to us. Learn how we collect, use, and protect your data.
              </p>
            </div>
            <div className="col-md-4 text-md-end mt-3 mt-md-0">
              <Link to="/" className="btn btn-light btn-lg">
                <i className="bi bi-arrow-left me-2"></i>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0" style={{ borderRadius: "20px" }}>
              <div className="card-body p-5">
                <p className="text-muted mb-4">
                  <strong>Last Updated:</strong> January 13, 2026
                </p>

                <div className="alert alert-info mb-5">
                  <i className="bi bi-info-circle-fill me-2"></i>
                  This Privacy Policy explains how SportsBid Arena ("we", "us", or "our") collects, 
                  uses, and protects your personal information when you use our website and services.
                </div>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-collection text-primary me-2"></i>
                    Information We Collect
                  </h2>
                  
                  <h3 className="h5 fw-semibold mt-4 mb-3">Personal Information</h3>
                  <p>When you register for an account, we may collect:</p>
                  <ul>
                    <li>Name and email address</li>
                    <li>Phone number (optional)</li>
                    <li>Profile picture (optional)</li>
                    <li>Account credentials (securely stored)</li>
                  </ul>

                  <h3 className="h5 fw-semibold mt-4 mb-3">Auction Data</h3>
                  <p>When you use our services, we collect:</p>
                  <ul>
                    <li>Game/auction information you create</li>
                    <li>Team and player data you upload</li>
                    <li>Bidding history and transactions</li>
                    <li>Images and logos you upload</li>
                  </ul>

                  <h3 className="h5 fw-semibold mt-4 mb-3">Automatically Collected Information</h3>
                  <p>We automatically collect certain information when you visit our site:</p>
                  <ul>
                    <li>IP address and browser type</li>
                    <li>Device information and operating system</li>
                    <li>Pages visited and time spent on site</li>
                    <li>Referring website or source</li>
                    <li>Cookies and similar tracking technologies</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-gear text-primary me-2"></i>
                    How We Use Your Information
                  </h2>
                  <p>We use the collected information to:</p>
                  <ul>
                    <li>Provide and maintain our Service</li>
                    <li>Create and manage your account</li>
                    <li>Enable auction creation and participation</li>
                    <li>Process real-time bidding activities</li>
                    <li>Send important notifications about your auctions</li>
                    <li>Respond to your inquiries and support requests</li>
                    <li>Improve our Service and user experience</li>
                    <li>Detect and prevent fraud or abuse</li>
                    <li>Comply with legal obligations</li>
                    <li>Display relevant advertisements (via Google Ads)</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-share text-primary me-2"></i>
                    Information Sharing
                  </h2>
                  <p>We may share your information with:</p>
                  
                  <h3 className="h5 fw-semibold mt-4 mb-3">Other Users</h3>
                  <p>
                    Certain information is visible to other users within your auction, such as 
                    your name, team information, and bidding activities. This is necessary for 
                    the auction functionality.
                  </p>

                  <h3 className="h5 fw-semibold mt-4 mb-3">Service Providers</h3>
                  <p>We use third-party services to operate our platform:</p>
                  <ul>
                    <li><strong>Firebase (Google):</strong> Authentication and database services</li>
                    <li><strong>Appwrite:</strong> File storage for images and media</li>
                    <li><strong>Google Analytics:</strong> Website analytics</li>
                    <li><strong>Google AdSense:</strong> Advertisement delivery</li>
                  </ul>

                  <h3 className="h5 fw-semibold mt-4 mb-3">Legal Requirements</h3>
                  <p>
                    We may disclose your information if required by law, court order, or 
                    government request, or to protect our rights, safety, or property.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-cookie text-primary me-2"></i>
                    Cookies and Tracking
                  </h2>
                  <p>
                    We use cookies and similar tracking technologies to enhance your experience. 
                    Types of cookies we use:
                  </p>
                  <ul>
                    <li><strong>Essential Cookies:</strong> Required for the Service to function</li>
                    <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our site</li>
                    <li><strong>Advertising Cookies:</strong> Used by Google AdSense to serve relevant ads</li>
                    <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
                  </ul>
                  <p>
                    You can control cookies through your browser settings. However, disabling certain 
                    cookies may affect the functionality of our Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-megaphone text-primary me-2"></i>
                    Advertising
                  </h2>
                  <p>
                    We use Google AdSense to display advertisements on our website. Google may use 
                    cookies to serve ads based on your prior visits to our website or other websites.
                  </p>
                  <p>
                    You can opt out of personalized advertising by visiting{" "}
                    <a 
                      href="https://www.google.com/settings/ads" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      Google Ads Settings
                    </a>
                    {" "}or{" "}
                    <a 
                      href="https://www.aboutads.info/choices/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      www.aboutads.info
                    </a>.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-lock text-primary me-2"></i>
                    Data Security
                  </h2>
                  <p>
                    We implement appropriate security measures to protect your personal information:
                  </p>
                  <ul>
                    <li>Secure HTTPS encryption for all data transmission</li>
                    <li>Secure authentication via Firebase Auth</li>
                    <li>Regular security updates and monitoring</li>
                    <li>Limited access to personal data by authorized personnel only</li>
                  </ul>
                  <p>
                    However, no method of transmission over the Internet is 100% secure. We cannot 
                    guarantee absolute security of your data.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-clock-history text-primary me-2"></i>
                    Data Retention
                  </h2>
                  <p>
                    We retain your personal information for as long as your account is active or 
                    as needed to provide you services. We may retain certain information as required 
                    by law or for legitimate business purposes.
                  </p>
                  <p>
                    Auction data (games, teams, players) is retained unless you explicitly request 
                    deletion. You can delete your auctions through your dashboard.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-person-check text-primary me-2"></i>
                    Your Rights
                  </h2>
                  <p>You have the right to:</p>
                  <ul>
                    <li><strong>Access:</strong> Request a copy of your personal data</li>
                    <li><strong>Correction:</strong> Update or correct inaccurate information</li>
                    <li><strong>Deletion:</strong> Request deletion of your personal data</li>
                    <li><strong>Portability:</strong> Request your data in a portable format</li>
                    <li><strong>Objection:</strong> Object to certain processing of your data</li>
                    <li><strong>Withdraw Consent:</strong> Withdraw consent where processing is based on consent</li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us at{" "}
                    <a href="mailto:rshuvo036@gmail.com">rshuvo036@gmail.com</a>.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-people text-primary me-2"></i>
                    Children's Privacy
                  </h2>
                  <p>
                    Our Service is not intended for children under 13 years of age. We do not 
                    knowingly collect personal information from children under 13. If you are a 
                    parent or guardian and believe your child has provided us with personal 
                    information, please contact us.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-globe text-primary me-2"></i>
                    International Data Transfers
                  </h2>
                  <p>
                    Your information may be transferred to and processed in countries other than 
                    your own. Our service providers (Firebase, Appwrite, Google) may store data 
                    in various locations worldwide. By using our Service, you consent to such transfers.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-arrow-repeat text-primary me-2"></i>
                    Changes to This Policy
                  </h2>
                  <p>
                    We may update this Privacy Policy from time to time. We will notify you of 
                    significant changes by posting a notice on our website or sending you an email. 
                    Your continued use of the Service after changes constitutes acceptance of the 
                    updated policy.
                  </p>
                </section>

                <section className="mb-4">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-envelope text-primary me-2"></i>
                    Contact Us
                  </h2>
                  <p>
                    If you have any questions about this Privacy Policy or our data practices, 
                    please contact us:
                  </p>
                  <div className="bg-light p-4 rounded">
                    <p className="mb-2">
                      <i className="bi bi-envelope-fill text-primary me-2"></i>
                      <strong>Email:</strong>{" "}
                      <a href="mailto:rshuvo036@gmail.com">rshuvo036@gmail.com</a>
                    </p>
                    <p className="mb-0">
                      <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                      <strong>Address:</strong> Rajshahi, Bangladesh
                    </p>
                  </div>
                </section>

                <div className="text-center mt-5 pt-4 border-top">
                  <Link to="/" className="btn btn-primary btn-lg me-3">
                    <i className="bi bi-house me-2"></i>
                    Back to Home
                  </Link>
                  <Link to="/terms-and-conditions" className="btn btn-outline-primary btn-lg">
                    <i className="bi bi-file-earmark-text me-2"></i>
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-4 bg-dark text-white text-center">
        <div className="container">
          <small className="text-white-50">
            © 2025 SportsBid Arena. All rights reserved.
          </small>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
